import { render, staticRenderFns } from "./change-phone.vue?vue&type=template&id=a86e00d0&scoped=true"
import script from "./change-phone.vue?vue&type=script&lang=js"
export * from "./change-phone.vue?vue&type=script&lang=js"
import style0 from "./change-phone.vue?vue&type=style&index=0&id=a86e00d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86e00d0",
  null
  
)

export default component.exports